import PlaceholderPage from './PlaceholderPage';

function Success() {
  return <PlaceholderPage title="Success" />;
}

export default Success;
